import { render, staticRenderFns } from "./PagePreviewFolder.vue?vue&type=template&id=13bba661"
import script from "./PagePreviewFolder.vue?vue&type=script&lang=js"
export * from "./PagePreviewFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports